import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "tree-item"
};
const _hoisted_2 = {
  class: "flex-column-box border-left-box"
};
const _hoisted_3 = {
  class: "label"
};
const _hoisted_4 = {
  class: "text"
};
const _hoisted_5 = {
  key: 1,
  class: "tree-item"
};
const _hoisted_6 = {
  class: "totalBar flex-row-box"
};
const _hoisted_7 = {
  key: 0,
  class: "tree-item"
};
const _hoisted_8 = {
  class: "flex-column-box border-left-box"
};
const _hoisted_9 = {
  class: "label"
};
const _hoisted_10 = {
  class: "text"
};
const _hoisted_11 = {
  key: 1,
  class: "tree-item"
};
const _hoisted_12 = {
  class: "dialog-footer"
};
import { ref, reactive, nextTick } from 'vue';
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { getAppTeamAllGroupUserListApi, updateAppTeamResourceAuth } from '@/request/team.ts';
export default /*@__PURE__*/_defineComponent({
  __name: 'AuthDialog',
  emits: ["refresh"],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const leftTreeRef = ref();
    const rightTreeRef = ref();
    const checkedKeys = ref();
    const checkedTreeData = ref([]);
    const getCheckedTreeData = treeData => {
      const newData = [];
      treeData.forEach(v => {
        const item = {
          ...v
        };
        if (item.children) {
          const newChildren = item.children.filter(c => checkedKeys.value.includes(c.value));
          if (newChildren.length) {
            item.children = newChildren;
            newData.push(item);
          }
        } else {
          if (checkedKeys.value.includes(v.value)) {
            newData.push(item);
          }
        }
      });
      return newData;
    };
    const data = ref([]);
    const usersItem = {
      label: '成员',
      value: 'users',
      children: undefined
    };
    // 资源类型 1：形象，2：音色，3：作品
    const getData = async row => {
      var _res$data, _resData$users, _resData$groups;
      let resourceId = null;
      if (row.activeType == 1) {
        resourceId = row.virtualManId;
      } else if (row.activeType == 2) {
        resourceId = row.timbreId;
      } else if (row.activeType == 3) {
        resourceId = row.id;
      } else if (row.activeType == 4) {
        resourceId = row.id;
      }
      const res = await getAppTeamAllGroupUserListApi({
        teamId: row.teamId,
        type: row.activeType,
        resourceId: resourceId
      });
      const resData = (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || {};
      usersItem.children = (_resData$users = resData.users) === null || _resData$users === void 0 ? void 0 : _resData$users.map(v => ({
        ...v,
        label: v.nickName,
        value: `user-${v.userId}`
      }));
      const list = [usersItem].concat((_resData$groups = resData.groups) === null || _resData$groups === void 0 ? void 0 : _resData$groups.map(v => ({
        ...v,
        label: v.groupName,
        value: `group-${v.groupId}`
      })));
      data.value = list;
      nextTick(() => {
        var _resData$users2, _resData$groups2;
        const checkedData = [...((_resData$users2 = resData.users) === null || _resData$users2 === void 0 ? void 0 : _resData$users2.filter(v => v.checked).map(v => `user-${v.userId}`)), ...((_resData$groups2 = resData.groups) === null || _resData$groups2 === void 0 ? void 0 : _resData$groups2.filter(v => v.checked).map(v => `group-${v.groupId}`))];
        console.log('++++', data.value, checkedData);
        // leftTreeRef.value.setCheckedKeys=checkedData;
        checkedKeys.value = checkedData;
        checkedTreeData.value = getCheckedTreeData(data.value);
      });
    };
    const handleCheckChange = (node, checkedData) => {
      checkedKeys.value = checkedData.checkedKeys;
      checkedTreeData.value = getCheckedTreeData(data.value);
    };
    const defaultProps = {
      children: 'children',
      label: 'label'
    };
    const formRef = ref();
    const emits = __emit;
    // 表单
    let form = ref({
      publicType: 1
    });
    const handleClear = () => {
      checkedKeys.value = undefined;
      checkedTreeData.value = [];
      leftTreeRef.value.setCheckedKeys([]);
    };
    // 弹框数据
    const dialogData = reactive({
      isShow: false,
      id: null
    });
    const rowData = ref();
    // 打开弹框
    const openDialog = async row => {
      console.log('openDialog...');
      console.log(row);
      dialogData.isShow = true;
      rowData.value = row;
      getData(row);
    };
    // 关闭弹框
    const closeDialog = () => {
      dialogData.isShow = false;
      form.value = {
        publicType: 1
      };
      rowData.value = undefined;
      checkedKeys.value = [];
      checkedTreeData.value = [];
    };
    // 提交
    const submit = async () => {
      var _rowData$value, _rowData$value3, _rowData$value5, _rowData$value7, _rowData$value9, _rowData$value10, _checkedKeys$value, _checkedKeys$value2;
      console.log('rowData.value...');
      console.log(rowData.value);
      let resourceId = null;
      if (((_rowData$value = rowData.value) === null || _rowData$value === void 0 ? void 0 : _rowData$value.activeType) == 1) {
        var _rowData$value2;
        resourceId = (_rowData$value2 = rowData.value) === null || _rowData$value2 === void 0 ? void 0 : _rowData$value2.virtualManId;
      } else if (((_rowData$value3 = rowData.value) === null || _rowData$value3 === void 0 ? void 0 : _rowData$value3.activeType) == 2) {
        var _rowData$value4;
        resourceId = (_rowData$value4 = rowData.value) === null || _rowData$value4 === void 0 ? void 0 : _rowData$value4.timbreId;
      } else if (((_rowData$value5 = rowData.value) === null || _rowData$value5 === void 0 ? void 0 : _rowData$value5.activeType) == 3) {
        var _rowData$value6;
        resourceId = (_rowData$value6 = rowData.value) === null || _rowData$value6 === void 0 ? void 0 : _rowData$value6.id;
      } else if (((_rowData$value7 = rowData.value) === null || _rowData$value7 === void 0 ? void 0 : _rowData$value7.activeType) == 4) {
        var _rowData$value8;
        resourceId = (_rowData$value8 = rowData.value) === null || _rowData$value8 === void 0 ? void 0 : _rowData$value8.id;
      }
      console.log('resourceId:' + resourceId);
      const params = {
        teamId: (_rowData$value9 = rowData.value) === null || _rowData$value9 === void 0 ? void 0 : _rowData$value9.teamId,
        publicType: form.value.publicType,
        type: (_rowData$value10 = rowData.value) === null || _rowData$value10 === void 0 ? void 0 : _rowData$value10.activeType,
        resourceId: resourceId,
        userIds: (_checkedKeys$value = checkedKeys.value) === null || _checkedKeys$value === void 0 || (_checkedKeys$value = _checkedKeys$value.filter(v => v.startsWith('user-'))) === null || _checkedKeys$value === void 0 ? void 0 : _checkedKeys$value.map(v => v.split('user-')[1]),
        groupIds: (_checkedKeys$value2 = checkedKeys.value) === null || _checkedKeys$value2 === void 0 || (_checkedKeys$value2 = _checkedKeys$value2.filter(v => v.startsWith('group-'))) === null || _checkedKeys$value2 === void 0 ? void 0 : _checkedKeys$value2.map(v => v.split('group-')[1])
      };
      updateAppTeamResourceAuth({
        ...params
      }).then(() => {
        ElMessage.success('操作成功');
        closeDialog();
        emits('refresh');
      });
    };
    __expose({
      openDialog
    });
    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_image = _resolveComponent("el-image");
      const _component_svgIcon = _resolveComponent("svgIcon");
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        width: "900px",
        title: "资源权限",
        center: "",
        "model-value": dialogData.isShow,
        "destroy-on-close": "",
        onClose: closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("确定")])),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: closeDialog
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("取消")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          class: "modal",
          model: _unref(form),
          ref_key: "formRef",
          ref: formRef,
          "label-width": "90px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "公开类型"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).publicType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).publicType = $event)
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio, {
                    value: 1
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("团队权限")])),
                    _: 1
                  }), _createVNode(_component_el_radio, {
                    value: 2
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("私人权限")])),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tree, {
                ref_key: "leftTreeRef",
                ref: leftTreeRef,
                "default-checked-keys": checkedKeys.value,
                "node-key": "value",
                class: "tree",
                style: {
                  "max-width": "600px"
                },
                data: data.value,
                "expand-on-click-node": false,
                props: defaultProps,
                "show-checkbox": "",
                onCheck: handleCheckChange
              }, {
                default: _withCtx(({
                  node,
                  data
                }) => [node.data.userId ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_image, {
                  class: "avatar",
                  src: node.data.head
                }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(node.data.nickname), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(node.data.phone), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_svgIcon, {
                  iconClass: "group",
                  width: "0.833vw"
                }), _createTextVNode("  " + _toDisplayString(node.label), 1)]))]),
                _: 1
              }, 8, ["default-checked-keys", "data"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => {
                var _checkedKeys$value3;
                return [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, "已选：" + _toDisplayString(((_checkedKeys$value3 = checkedKeys.value) === null || _checkedKeys$value3 === void 0 ? void 0 : _checkedKeys$value3.length) || 0) + "人", 1), _cache[4] || (_cache[4] = _createTextVNode()), _createVNode(_component_el_button, {
                  type: "text",
                  onClick: handleClear
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("全部清除")])),
                  _: 1
                })]), _createVNode(_component_el_tree, {
                  ref_key: "rightTreeRef",
                  ref: rightTreeRef,
                  "node-key": "value",
                  class: "tree",
                  style: {
                    "max-width": "600px"
                  },
                  data: checkedTreeData.value,
                  "expand-on-click-node": true,
                  props: defaultProps
                }, {
                  default: _withCtx(({
                    node,
                    data
                  }) => [node.data.userId ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_image, {
                    class: "avatar",
                    src: node.data.head
                  }, null, 8, ["src"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(node.data.nickname), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(node.data.phone), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_svgIcon, {
                    iconClass: "group",
                    width: "0.833vw"
                  }), _createTextVNode("  " + _toDisplayString(node.label), 1)]))]),
                  _: 1
                }, 8, ["data"])];
              }),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
});